// Links shown by ChatAccessNotice.
export const PRIVACY_TEAM_URL =
  "https://agricompany.sharepoint.com/sites/Globallegal#/privacy";
export const M365_COPILOT_URL =
  "https://vylor.service-now.com/sp?id=kb_article_view&sysparm_article=KB0040963&sys_kb_id=9c87d8803be33ed05a6f4a5ea5e45a5b";
export const TEAMS_UPDATES_THREAD_URL =
  "https://teams.microsoft.com/l/message/19:AY2rQKV1bnWs9BJa0G7IJeHNz45RAxOSdFGih8P0nEU1@thread.tacv2/1792429653314?tenantId=db505480-8ec6-495c-b579-32c58ed84a01&groupId=da408d6d-dc17-4de2-bbcd-2f027f1a154f&parentMessageId=1792429653314&teamName=Vylor%20Research%20Chat&channelName=Support-%20Vylor%20Research%20Chat&createdTime=1792429653314";
